import { render, staticRenderFns } from "./AwsImage.vue?vue&type=template&id=7bfac63e&"
import script from "./AwsImage.vue?vue&type=script&lang=js&"
export * from "./AwsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports